document.addEventListener('DOMContentLoaded', () => {
    const config = window.MARKETING_CONFIG;

    if (!config || Number(config.banner) !== 1) return;

    const banner = document.getElementById('cookie-banner');
    const texto = document.getElementById('cookie-text');
    const botonAceptar = document.getElementById('accept-cookies');
    const botonRechazar = document.getElementById('reject-cookies');

    if (!banner || !texto || !botonAceptar || !botonRechazar) return;

    const decisionGuardada = localStorage.getItem('cookiesDecision');

    texto.innerHTML = config.mensaje + ' <a href="/cookies" class="cookie-link">Leer política de cookies</a>';

    if (!decisionGuardada) {
        banner.style.display = 'flex';
    }

    if (decisionGuardada === 'accepted') {
        activarTracking(config);
    }

    botonAceptar.addEventListener('click', () => {
        localStorage.setItem('cookiesDecision', 'accepted');
        banner.style.display = 'none';
        activarTracking(config);
    });

    botonRechazar.addEventListener('click', () => {
        localStorage.setItem('cookiesDecision', 'rejected');
        banner.style.display = 'none';
    });
});

function activarTracking(config) {

    // 🔵 GOOGLE ANALYTICS (GA4)
    if (Number(config.googleAnalytics) === 1 && config.ga_id) {

        // Evitar cargarlo dos veces
        if (window.gaCargado) return;
        window.gaCargado = true;

        // Script principal de Google
        const scriptGA = document.createElement('script');
        scriptGA.src = `https://www.googletagmanager.com/gtag/js?id=${config.ga_id}`;
        scriptGA.async = true;
        document.head.appendChild(scriptGA);

        // Configuración GA4
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        window.gtag = gtag;

        gtag('js', new Date());
        gtag('config', config.ga_id);

        console.log('Google Analytics ACTIVADO:', config.ga_id);
    }

    //  META PIXEL
    if (Number(config.metaPixel) === 1 && config.pixel_id) {

        if (window.pixelCargado) return;
        window.pixelCargado = true;

        !(function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)})(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');

        fbq('init', config.pixel_id);
        fbq('track', 'PageView');

        console.log('Meta Pixel ACTIVADO:', config.pixel_id);
    }
}

function eventoWhatsApp() {
    document.querySelectorAll('a[href*="wa.me"]').forEach(boton => {

        boton.addEventListener('click', () => {

            const decision = localStorage.getItem('cookiesDecision');

            // ❌ Si no aceptó cookies, no hacer nada
            if (decision !== 'accepted') {
                console.log('Evento WhatsApp bloqueado (sin consentimiento)');
                return;
            }

            // ✔ Google Analytics
            if (typeof gtag === 'function') {
                gtag('event', 'click_whatsapp', {
                    event_category: 'contacto',
                    event_label: 'whatsapp'
                });
            }

            // ✔ Meta Pixel
            if (typeof fbq === 'function') {
                fbq('track', 'Contact');
            }

            console.log('Evento: WhatsApp');
        });

    });
}

// Ejecutar
eventoWhatsApp();

function eventoFormulario() {

    document.querySelectorAll('form').forEach(form => {

        form.addEventListener('submit', () => {

            const decision = localStorage.getItem('cookiesDecision');

            // ❌ Bloquear si no aceptó cookies
            if (decision !== 'accepted') {
                console.log('Evento formulario bloqueado (sin consentimiento)');
                return;
            }

            // ✔ Google Analytics
            if (typeof gtag === 'function') {
                gtag('event', 'form_submit', {
                    event_category: 'contacto',
                    event_label: 'formulario'
                });
            }

            // ✔ Meta Pixel
            if (typeof fbq === 'function') {
                fbq('track', 'Lead');
            }

            console.log('Evento: Formulario enviado');
        });

    });

}

// Ejecutar
eventoFormulario();

